export const dedupeById = <T extends { id: string | number }>(
  items: T[] = []
) => {
  const seen = new Set<string>();

  return items.filter((item) => {
    const id = String(item.id);
    if (seen.has(id)) return false;
    seen.add(id);
    return true;
  });
};
